import React, { useEffect, useState } from "react";
import AgentHeader from "../../components/agent-ui/AgentHeader";
// import SearchComp from "../../utils/search-comp";
// import ListHouses from "../../components/ui/ListHouses";
import { AxiosAuthGet } from "../../api/api";
import Loading from "../../components/ui/Loading";
import HouseCard from "../../components/ui/HouseCard";
import { useNavigate } from "react-router-dom";
import "../dev_dash/dev.css"
import Pagination from "../../utils/pagination";

const Property = () => {
  // const user = JSON.parse(localStorage.getItem("apk"));
  const [isLoading, setIsLoading] = useState(false);
  const [resData, setResData] = useState([]);
  const [pagData, setPagData] = useState();
  const [curPage, setCurPage] = useState(1);
  // const btnArr = ["All", "For Rent", "For Sale"];
  const navigate = useNavigate();

  // const url = `agents/${user?.data?.id}/properties/?page=${curPage}&page_size=9`;
  const url = `agent/properties/?page=${curPage}&page_size=10`;

  const getRes = () => {
    setIsLoading(true);
    AxiosAuthGet(url)
      .then((res) => {
        // console.log(res);
        setResData(res.data);
        setPagData(res.pagination);
        setIsLoading(false);
      })
      .catch((err) => {
        // console.error(err.response);
        setIsLoading(false);
      });
  };
  

  useEffect(() => {
    getRes();
    // eslint-disable-next-line
  }, [curPage]);

  const clickNext = () => {
    setCurPage(pagData?.nextPage);
  };
  const clickPrev = () => {
    setCurPage(pagData?.previousPage);
  };

  
  const viewProp = (item) => {
    localStorage.setItem('singleAgentProp', JSON.stringify(item));
    navigate("/agent/property/house-view/:id");
  };

  return (
    <div>
      <AgentHeader
        header={"Property Listings"}
        placeholder={"Search for property"}
        isSearch
      />
      {/* <SearchComp
        sortBy
        priceRange
        location
        handlePropertyChange={handlePropChange}
        handleLocChange={handleLocChange}
        handlePriceChange={handlePriceChange}
        handleSortChange={handleSortChange}
        options={options}
        optionsLoc={optionsLoc}
        optionsPrice={optionsPriceArr}
        widthStyle={"100%"}
      /> */}
      {isLoading && <Loading />}
      {!isLoading && (
        <>
          {/* {resData?.length <= 0 && (
            <p className="emp_p">Nothing to show here.</p>
          )}
          
          {resData?.length > 0 && (
            <ListHouses
              btnArr={btnArr}
              pag={pagData}
              houseData={resData}
              clickNext={clickNext}
              clickPrev={clickPrev}
            />
          )} */}
          
          <div className="estates_houses">
            {resData.length === 0 ? <p className="emp_p">Nothing to show here</p> : resData?.map((item, idx) => {
              return (
                <HouseCard
                  key={idx}
                  tag={item?.isVerified}
                  price={`#${item?.propertyPrice?.toLocaleString()}` }
                  add={item.propertyAddress}
                  // bath={item.bath}
                  // bed={item.bed}
                  propType={item?.propertyType}
                  noOfUnits={item?.numberOfUnits}
                  title={item?.name}
                  btnClick={() => viewProp(item)}
                  img={item?.images[0]?.link}
                  houseStyle={{width: '30%'}}
                />
              );
            })}
          </div>
                  {pagData && (
          <Pagination
            clickNext={clickNext}
            clickPrev={clickPrev}
            pagData={pagData}
          />
        )}
        </>
      )}
    </div>
  );
};

export default Property;
